const STORAGE_PREFIX = 'eatd-active-tab:';
const DEFAULT_TAB = 'operator';

const canUseStorage = () => typeof window !== 'undefined' && !!window.sessionStorage;

export const getEatdActiveTab = (instanceId) => {
  if (!instanceId || !canUseStorage()) return DEFAULT_TAB;

  const storedValue = window.sessionStorage.getItem(`${STORAGE_PREFIX}${instanceId}`);
  return storedValue || DEFAULT_TAB;
};

export const setEatdActiveTab = (instanceId, tab) => {
  if (!instanceId || !tab || !canUseStorage()) return;
  window.sessionStorage.setItem(`${STORAGE_PREFIX}${instanceId}`, tab);
};
